<template>
  <div>
    <div class="columns">
      <div class="column has-text-centered">
        <div class="buttons is-centered">
          <button
            v-for="(sel, ind) in selection"
            :key="ind"
            class="button"
            v-bind:class="active(index, ind + 1)"
            @click="selData(ind)"
          >
            {{ sel.nombre }}
          </button>
          <button
            class="button is-tooltip-info tooltip"
            data-tooltip="Agregar Registro"
            @click="agregarRegistro"
          >
            <span class="icon">
              <i class="material-icons">playlist_add</i>
            </span>
          </button>
          <button
            class="button is-tooltip-danger tooltip"
            data-tooltip="Eliminar Registro"
            v-show="fila !== 0"
            @click="eliminaRegistro"
          >
            <span class="icon">
              <i class="material-icons">delete_forever</i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="columns">
      <dir class="column is-half is-offset-one-quarter inputregister">
        <div class="field is-fullwidth has-addons">
          <div class="control">
            <a class="button" @click="f3">
              <span class="icon is-medium">
                <i class="material-icons">list_alt</i>
              </span>
            </a>
          </div>

          <div class="control is-expanded has-icons-left">
            <input
              v-model="inputReg"
              id="inputReg"
              class="input is-fullwidth is-primary"
              type="text"
              @keydown="keyfunction($event)"
              :placeholder="selection[columna - 1].nombre"
              autocomplete="off"
            />
            <span v-show="editsel" class="icon is-small is-left">
              <i class="material-icons">edit</i>
            </span>
            <span v-show="!editsel" class="icon is-small is-left">
              <i class="material-icons">control_camera</i>
            </span>
          </div>
          <div class="control">
            <a class="button is-primary" @click="ok">
              <span class="icon">
                <i class="material-icons">done_outline</i>
              </span>
            </a>
          </div>
        </div>
      </dir>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  //  v-bind:class="{ 'is-primary': active(index,ind+1), 'is-warning': fondo(index,ind+1) }"
  data() {
    return {
      inputReg: "",
      editsel: false,
      tercerosModal: [],
    };
  },
  computed: {
    ...mapState(["resultDatamodal", "idtoken", "nits", "productos", "bodegas"]),
  },
  props: {
    fila: Number,
    index: Number,
    columna: Number,
    selection: Array,
    lengthReg: Number,
    reg: Array,
    comundata: {
      type: Object,
    },
    selcolumn: Object,
    totalesfactura: Array,
  },
  methods: {
    async traeTerceros(_this, mes, year, idtercero, idcuenta) {
      let result;
      try {
        result = await apiServices.get(
          `/reporteportercero/${mes}/${year}/${idtercero}/${idcuenta}`
        );
        _this.tercerosModal = [];
        result.data.forEach((el) => {
          const d = {};
          d.codigo = el.docRef;
          d.nombre = functions.formatNumber(el.saldoInicial + el.mvto);
          d.id = el.docRef;
          d.selected = false;
          _this.tercerosModal.push(d);
        });

        this.$store.commit("launchModal", {
          title: "Seleccione el Documento",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Documento" },
            { cod: "nombre", name: "Saldo" },
          ],
          table: _this.tercerosModal,
          result: "inputReg",
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los comprobantes.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los comprobantes", err);
      }
    },
    f3() {
      const cod = this.selection[this.columna - 1].cod; // miramos de selection cual es el input seleccionado en el momento
      if (cod === "nproducto") {
        const dataproductos = this.productos.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.descripcion,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione el Producto",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: dataproductos,
          result: "inputReg",
        });
      }
      if (cod === "nbodega") {
        const databodega = this.bodegas.map((e) => {
          const d = {
            codigo: e.codigo,
            nombre: e.descripcion,
            id: e._id,
            selected: false,
          };
          return d;
        });
        this.$store.commit("launchModal", {
          title: "Seleccione la Bodega",
          oktext: "Aceptar",
          canceltext: "Cancelar",
          titleTable: [
            { cod: "codigo", name: "Código" },
            { cod: "nombre", name: "Nombre" },
          ],
          table: databodega,
          result: "inputReg",
        });
      }
      if (cod === "batchcodigo") {
        const _this = this;
        if (
          this.reg[this.index].objetoProducto &&
          this.reg[this.index].objetoProducto.lote &&
          this.reg[this.index].objetoProducto.lote[this.reg[this.index].bodega]
        ) {
          const datalote = this.reg[this.index].objetoProducto.lote[
            this.reg[this.index].bodega
          ].list.map((e) => {
            const d = {
              codigo: e,
              nombre: `${
                _this.reg[this.index].objetoProducto.lote[
                  _this.reg[_this.index].bodega
                ][e].nombre
              } - Existencia ${
                _this.reg[this.index].objetoProducto.lote[
                  _this.reg[_this.index].bodega
                ][e].existencia
              }`,
              id: e,
              selected: false,
            };
            return d;
          });
          this.$store.commit("launchModal", {
            title: "Seleccione el Lote",
            oktext: "Aceptar",
            canceltext: "Cancelar",
            titleTable: [
              { cod: "codigo", name: "Código" },
              { cod: "nombre", name: "Nombre" },
            ],
            table: datalote,
            result: "inputReg",
          });
        }
      }
    },
    agregarRegistro() {
      this.$emit("validaReg");
      if (this.reg[this.fila].cumpleTodo) {
        this.$emit("newReg");
      } else {
        this.$store.dispatch("notify", {
          message:
            "Antes de crear otro registro debe corregir los campos resaltados en color rojo.",
          type: "is-warning",
          position: "top-center",
          duration: 5000,
        });
      }
    },
    ok() {
      if (this.columna < this.selection.length) {
        this.$emit("columna", this.columna + 1);
      } else {
        if (this.fila < this.lengthReg - 1) {
          this.$emit("fila", this.fila + 1);
          this.$emit("columna", 1);
          setTimeout(function () {
            document.getElementById("inputReg").focus();
          }, 5);
        } else {
          this.$emit("validaReg");
          if (this.reg[this.fila].cumpleTodo) {
            // this.$emit("newReg");
            if (this.totalesfactura.length > 0) {
              this.$emit("fila", -2);
              this.$emit("filatotal", 0);
              setTimeout(function () {
                document.getElementById("inputRegtotal").focus();
              }, 5);
            }
          } else {
            this.$store.dispatch("notify", {
              message: "Debe corregir los campos resaltados en color rojo.",
              type: "is-warning",
              position: "top-center",
              duration: 5000,
            });
          }
          // aqui debe validar el renglon antes de crear el otro
        }
      }
    },
    chargeData(f, c) {
      if (c + 2 === this.selcolumn.columnDescuento) {
        if (this.reg[f][this.selection[c + 1].cod]) {
          // si ya tenia datos ponga el dato sino traiga el dato
          this.inputReg = this.reg[f][this.selection[c + 1].cod];
        } else if (
          this.reg[f - 1] &&
          this.reg[f - 1][this.selection[c + 1].cod]
        ) {
          this.inputReg = this.reg[f - 1][this.selection[c + 1].cod];
          // si no tenia dato traiga el del renglon anterior
        } else if (
          this.reg[f - 2] &&
          this.reg[f - 2][this.selection[c + 1].cod]
        ) {
          this.inputReg = this.reg[f - 2][this.selection[c + 1].cod];
        } else {
          this.inputReg = this.reg[f][this.selection[c + 1].cod];
        }
      } else {
        this.inputReg = this.reg[f][this.selection[c + 1].cod];
      }
    },
    selData(c) {
      this.$emit("columna", c + 1);
      document.getElementById("inputReg").focus();
    },
    active(f, c) {
      if (c === this.columna && f === this.fila) {
        return {
          "is-primary": true,
        };
      } else {
        if (this.reg[f][this.selection[c - 1].valida]) {
          return {
            // "is-light": true
          };
        } else {
          return {
            "is-danger": true,
          };
        }
      }
    },
    keyfunction(e) {
      console.log("el key code es", e.keyCode);
      if (e.keyCode === 121) {
        e.preventDefault();
        this.$emit("f10guardar");
      }
      if (e.keyCode === 113) {
        e.preventDefault();
        if (this.editsel) {
          this.editsel = false;
        } else {
          this.editsel = true;
        }
      }
      if (e.keyCode === 114) {
        e.preventDefault();
        this.f3();
      }
      if (e.keyCode === 39) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.columna < this.selection.length) {
            this.$emit("columna", this.columna + 1);
          }
        }
      }
      if (e.keyCode === 37) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.columna > 1) {
            this.$emit("columna", this.columna - 1);
          }
        }
      }
      if (e.keyCode === 40) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.fila < this.lengthReg - 1) {
            this.$emit("fila", this.fila + 1);
            setTimeout(function () {
              document.getElementById("inputReg").focus();
            }, 5);
          } else {
            if (this.totalesfactura.length > 0) {
              this.$emit("fila", -2);
              this.$emit("filatotal", 0);
              setTimeout(function () {
                document.getElementById("inputRegtotal").focus();
              }, 5);
            }
          }
        }
      }
      if (e.keyCode === 38) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.fila > 0) {
            this.$emit("fila", this.fila - 1);
            setTimeout(function () {
              document.getElementById("inputReg").focus();
            }, 5);
          } else if (this.fila === 0) {
            if (this.columna === 6) {
              // este if es para que no de error ya que el encabezado solo tiene 5 columnas.
              this.$emit("columna", 5);
            }
            this.$emit("fila", this.fila - 1);
            setTimeout(function () {
              document.getElementById("inputEncabezado").focus();
            }, 5);
          }
        }
      }
      if (e.keyCode === 13 || e.keyCode === 9) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        this.ok();
      }
    },
    eliminaRegistro() {
      this.$emit("deleteReg", this.fila);
    },
  },
  created() {
    this.chargeData(this.fila, this.columna - 2); // no se pone en un watcher porque el componente se crea cada que se cambia de columna
    if (this.fila !== 0) {
      setTimeout(function () {
        document.getElementById("inputReg").select();
      }, 5);
    }
  },
  watch: {
    inputReg(newv, oldv) {
      this.$emit("changeInputReg", {
        fila: this.fila,
        columna: this.columna,
        data: newv,
      });
    },
    columna(newv, oldv) {
      this.chargeData(this.fila, newv - 2);
      setTimeout(function () {
        document.getElementById("inputReg").select();
      }, 5);
    },
    resultDatamodal(newv, oldv) {
      if (newv.result === "inputReg") {
        this.inputReg = newv.data[newv.title[0].cod];
        document.getElementById("inputReg").focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inputregister {
  padding-top: 1px;
  margin-top: 1px;
}
.column {
  padding: 2px 15px 2px 15px;
}
</style>






// WEBPACK FOOTER //
// src/components/registrar/Formregistrofrapvta2.vue